// Maps canonical Uzbek city/district names → parent region translation key
export const SUBREGION_TO_PARENT_KEY = {
  // Tashkent city districts
  'Юнусобод тумани': 'tashkent_city', 'Чилонзор тумани': 'tashkent_city',
  'Мирзо-Улугбек тумани': 'tashkent_city', 'Яккасарой тумани': 'tashkent_city',
  'Шайхонтоҳур тумани': 'tashkent_city', 'Олмазор тумани': 'tashkent_city',
  'Учтепа тумани': 'tashkent_city', 'Сергели тумани': 'tashkent_city',
  'Бектемир тумани': 'tashkent_city', 'Яшнобод тумани': 'tashkent_city',
  'Миробод тумани': 'tashkent_city',
  // Tashkent region cities
  'Нурафшон': 'tashkent', 'Чирчиқ': 'tashkent', 'Олмалиқ': 'tashkent',
  'Ангрен': 'tashkent', 'Бекобод': 'tashkent', 'Янгийўл': 'tashkent', 'Оҳангарон': 'tashkent',
  // Tashkent region districts
  'Зангиота тумани': 'tashkent', 'Қибрай тумани': 'tashkent',
  'Бўстонлиқ тумани': 'tashkent', 'Бўка тумани': 'tashkent',
  'Паркент тумани': 'tashkent', 'Пскент тумани': 'tashkent', 'Тошкент тумани': 'tashkent',
  'Ўртачирчиқ тумани': 'tashkent', 'Юқоричирчиқ тумани': 'tashkent',
  'Чиноз тумани': 'tashkent', 'Оққўрғон тумани': 'tashkent',
  'Қуйи Чирчиқ тумани': 'tashkent', 'Оҳангарон тумани': 'tashkent',
  // Andijan
  'Андижон': 'andijan',
  'Андижон тумани': 'andijan', 'Асака тумани': 'andijan', 'Хўжаобод тумани': 'andijan',
  'Жалақудуқ тумани': 'andijan', 'Мархамат тумани': 'andijan',
  'Балиқчи тумани': 'andijan', 'Булоқбоши тумани': 'andijan', 'Бўстон тумани': 'andijan',
  'Избоскан тумани': 'andijan', 'Олтинкўл тумани': 'andijan',
  'Қўрғонтепа тумани': 'andijan', 'Пахтаобод тумани': 'andijan',
  'Улуғнор тумани': 'andijan', 'Хонобод тумани': 'andijan', 'Шаҳрихон тумани': 'andijan',
  // Fergana
  'Фарғона': 'fergana', 'Қўқон': 'fergana', 'Марғилон': 'fergana', 'Қувасой': 'fergana',
  'Қува тумани': 'fergana', 'Риштон тумани': 'fergana', 'Бағдод тумани': 'fergana',
  'Бешариқ тумани': 'fergana', 'Бувайда тумани': 'fergana', 'Данғара тумани': 'fergana',
  'Қуштепа тумани': 'fergana', 'Сўх тумани': 'fergana',
  'Тошлоқ тумани': 'fergana', 'Фурқат тумани': 'fergana', 'Ёзёвон тумани': 'fergana',
  // Namangan
  'Наманган': 'namangan',
  'Чуст тумани': 'namangan', 'Поп тумани': 'namangan', 'Косонсой тумани': 'namangan',
  'Давлатобод тумани': 'namangan', 'Мингбулоқ тумани': 'namangan', 'Норин тумани': 'namangan',
  'Тўрақўрғон тумани': 'namangan', 'Уйчи тумани': 'namangan',
  'Учқўрғон тумани': 'namangan', 'Янгиқўрғон тумани': 'namangan',
  'Янги Наманган тумани': 'namangan', 'Чортоқ тумани': 'namangan',
  // Samarkand
  'Самарқанд': 'samarkand', 'Каттақўрғон': 'samarkand',
  'Ургут тумани': 'samarkand', 'Пайариқ тумани': 'samarkand', 'Иштихон тумани': 'samarkand',
  'Жомбой тумани': 'samarkand',
  'Оқдарё тумани': 'samarkand', 'Булунғур тумани': 'samarkand',
  'Қўшрабод тумани': 'samarkand', 'Нарпай тумани': 'samarkand',
  'Нуробод тумани': 'samarkand', 'Пастдарғом тумани': 'samarkand',
  'Пахтачи тумани': 'samarkand', 'Тайлоқ тумани': 'samarkand',
  // Bukhara
  'Бухоро': 'bukhara', 'Когон тумани': 'bukhara',
  'Ромитан тумани': 'bukhara', 'Қоракўл тумани': 'bukhara', 'Ғиждувон тумани': 'bukhara',
  'Вобкент тумани': 'bukhara', 'Жондор тумани': 'bukhara',
  'Қоровулбозор тумани': 'bukhara', 'Олот тумани': 'bukhara',
  'Пешку тумани': 'bukhara', 'Шофиркон тумани': 'bukhara',
  // Navoi
  'Навоий': 'navoi', 'Зарафшон': 'navoi', 'Ғозғон': 'navoi',
  'Учқудуқ тумани': 'navoi', 'Нурота тумани': 'navoi', 'Конимех тумани': 'navoi',
  'Кармана тумани': 'navoi', 'Қизилтепа тумани': 'navoi',
  'Навбаҳор тумани': 'navoi', 'Томди тумани': 'navoi', 'Хатирчи тумани': 'navoi',
  // Kashkadarya
  'Қарши': 'kashkadarya', 'Шаҳрисабз': 'kashkadarya',
  'Қарши тумани': 'kashkadarya', 'Китоб тумани': 'kashkadarya',
  'Косон тумани': 'kashkadarya', 'Муборак тумани': 'kashkadarya',
  'Ғузор тумани': 'kashkadarya', 'Деҳқонобод тумани': 'kashkadarya',
  'Қамаши тумани': 'kashkadarya', 'Қасби тумани': 'kashkadarya',
  'Кўкдала тумани': 'kashkadarya', 'Миришкор тумани': 'kashkadarya',
  'Нишон тумани': 'kashkadarya', 'Чироқчи тумани': 'kashkadarya', 'Яккабоғ тумани': 'kashkadarya',
  // Surkhandarya
  'Термиз': 'surkhandarya',
  'Ангор тумани': 'surkhandarya', 'Денов тумани': 'surkhandarya', 'Шеробод тумани': 'surkhandarya',
  'Бойсун тумани': 'surkhandarya', 'Бандихон тумани': 'surkhandarya',
  'Жарқўрғон тумани': 'surkhandarya', 'Қизириқ тумани': 'surkhandarya',
  'Қумқўрғон тумани': 'surkhandarya', 'Музработ тумани': 'surkhandarya',
  'Олтинсой тумани': 'surkhandarya', 'Сариосиё тумани': 'surkhandarya',
  'Узун тумани': 'surkhandarya', 'Шўрчи тумани': 'surkhandarya',
  // Jizzakh
  'Жиззах': 'jizzakh',
  'Зомин тумани': 'jizzakh', 'Ғаллаорол тумани': 'jizzakh', 'Янгиобод тумани': 'jizzakh',
  'Арнасой тумани': 'jizzakh', 'Бахмал тумани': 'jizzakh', 'Дўстлик тумани': 'jizzakh',
  'Зарбдор тумани': 'jizzakh', 'Зафаробод тумани': 'jizzakh',
  'Мирзачўл тумани': 'jizzakh', 'Пахтакор тумани': 'jizzakh',
  'Фориш тумани': 'jizzakh', 'Шароф Рашидов тумани': 'jizzakh',
  // Sirdarya
  'Гулистон': 'sirdarya', 'Янгиер': 'sirdarya', 'Ширин': 'sirdarya',
  'Хавос тумани': 'sirdarya', 'Сардоба тумани': 'sirdarya',
  'Оқолтин тумани': 'sirdarya', 'Боёвут тумани': 'sirdarya',
  'Мирзаобод тумани': 'sirdarya', 'Сайхунобод тумани': 'sirdarya',
  'Сирдарё тумани': 'sirdarya',
  // Khorezm
  'Урганч': 'khorezm', 'Хива': 'khorezm', 'Питнак': 'khorezm',
  'Хонқа тумани': 'khorezm', 'Шовот тумани': 'khorezm', 'Боғот тумани': 'khorezm',
  'Гурлан тумани': 'khorezm', 'Қўшкўпир тумани': 'khorezm',
  'Хазорасп тумани': 'khorezm', 'Янгиариқ тумани': 'khorezm', 'Янгибозор тумани': 'khorezm',
  // Karakalpakstan
  'Нукус': 'karakalpakstan', 'Тахиатош': 'karakalpakstan',
  'Тўрткўл': 'karakalpakstan', 'Хўжайли': 'karakalpakstan', 'Чимбой': 'karakalpakstan',
  'Беруний тумани': 'karakalpakstan', 'Қўнғирот тумани': 'karakalpakstan',
  'Амударё тумани': 'karakalpakstan', 'Кегейли тумани': 'karakalpakstan',
  'Қонликўл тумани': 'karakalpakstan', 'Мўйноқ тумани': 'karakalpakstan',
  'Тахиатош тумани': 'karakalpakstan', 'Тахтакўпир тумани': 'karakalpakstan',
  'Шўманай тумани': 'karakalpakstan', 'Элликқалъа тумани': 'karakalpakstan',
};

// Oblast/top-level canonical → translation key
export const OBLAST_TO_KEY = {
  'Тошкент': 'tashkent_city',
  'Тошкент вилояти': 'tashkent',
  'Андижон вилояти': 'andijan',
  'Фарғона вилояти': 'fergana',
  'Наманган вилояти': 'namangan',
  'Самарқанд вилояти': 'samarkand',
  'Бухоро вилояти': 'bukhara',
  'Навоий вилояти': 'navoi',
  'Қашқадарё вилояти': 'kashkadarya',
  'Сурхондарё вилояти': 'surkhandarya',
  'Жиззах вилояти': 'jizzakh',
  'Сирдарё вилояти': 'sirdarya',
  'Хоразм вилояти': 'khorezm',
  'Қорақалпоғистон': 'karakalpakstan',
  // River/region names stored without "вилояти" — treat as oblast
  'Қашқадарё': 'kashkadarya',
  'Сурхондарё': 'surkhandarya',
  'Сирдарё': 'sirdarya',
  'Хоразм': 'khorezm',
};

// City names that need "шаҳри" appended in display (canonical → display label)
const CITY_LABEL = {
  // Tashkent region cities
  'Нурафшон': 'Нурафшон шаҳри', 'Чирчиқ': 'Чирчиқ шаҳри',
  'Олмалиқ': 'Олмалиқ шаҳри', 'Ангрен': 'Ангрен шаҳри',
  'Бекобод': 'Бекобод шаҳри', 'Янгийўл': 'Янгийўл шаҳри', 'Оҳангарон': 'Оҳангарон шаҳри',
  // Andijan
  'Андижон': 'Андижон шаҳри',
  // Fergana
  'Фарғона': 'Фарғона шаҳри', 'Қўқон': 'Қўқон шаҳри',
  'Марғилон': 'Марғилон шаҳри', 'Қувасой': 'Қувасой шаҳри',
  // Namangan
  'Наманган': 'Наманган шаҳри',
  // Samarkand
  'Самарқанд': 'Самарқанд шаҳри', 'Каттақўрғон': 'Каттақўрғон шаҳри',
  // Bukhara
  'Бухоро': 'Бухоро шаҳри',
  // Navoi
  'Навоий': 'Навоий шаҳри', 'Зарафшон': 'Зарафшон шаҳри', 'Ғозғон': 'Ғозғон шаҳри',
  // Kashkadarya
  'Қарши': 'Қарши шаҳри', 'Шаҳрисабз': 'Шаҳрисабз шаҳри',
  // Surkhandarya
  'Термиз': 'Термиз шаҳри',
  // Jizzakh
  'Жиззах': 'Жиззах шаҳри',
  // Sirdarya
  'Гулистон': 'Гулистон шаҳри', 'Янгиер': 'Янгиер шаҳри', 'Ширин': 'Ширин шаҳри',
  // Khorezm
  'Урганч': 'Урганч шаҳри', 'Хива': 'Хива шаҳри', 'Питнак': 'Питнак шаҳри',
  // Karakalpakstan
  'Нукус': 'Нукус шаҳри', 'Тахиатош': 'Тахиатош шаҳри',
  'Тўрткўл': 'Тўрткўл шаҳри', 'Хўжайли': 'Хўжайли шаҳри', 'Чимбой': 'Чимбой шаҳри',
};

// Russian display labels for cities and districts
const CITY_LABEL_RU = {
  // Tashkent city districts
  'Юнусобод тумани':'Юнусабадский район','Чилонзор тумани':'Чиланзарский район',
  'Мирзо-Улугбек тумани':'Мирзо-Улугбекский район','Яккасарой тумани':'Яккасарайский район',
  'Шайхонтоҳур тумани':'Шайхантахурский район','Олмазор тумани':'Алмазарский район',
  'Учтепа тумани':'Учтепинский район','Сергели тумани':'Сергелийский район',
  'Бектемир тумани':'Бектемирский район',
  // Tashkent region cities
  'Нурафшон':'г. Нурафшон','Чирчиқ':'г. Чирчик','Олмалиқ':'г. Алмалык',
  'Ангрен':'г. Ангрен','Бекобод':'г. Бекабад','Янгийўл':'г. Янгиюль','Оҳангарон':'г. Охангарон',
  // Tashkent region districts
  'Зангиота тумани':'Зангиатинский район','Қибрай тумани':'Кибрайский район',
  'Бўстонлиқ тумани':'Бостанлыкский район','Бўка тумани':'Букинский район',
  'Паркент тумани':'Паркентский район','Пскент тумани':'Пскентский район',
  'Тошкент тумани':'Ташкентский район','Ўртачирчиқ тумани':'Уртачирчикский район',
  'Юқоричирчиқ тумани':'Юкоричирчикский район','Чиноз тумани':'Чиназский район',
  'Оққўрғон тумани':'Аккурганский район','Қуйи Чирчиқ тумани':'Куйичирчикский район',
  // Andijan
  'Андижон':'г. Андижан','Андижон тумани':'Андижанский район','Асака тумани':'Асакинский район',
  'Балиқчи тумани':'Балыкчинский район','Булоқбоши тумани':'Булакбашский район',
  'Бўстон тумани':'Бустанский район','Жалақудуқ тумани':'Джалалкудукский район',
  'Избоскан тумани':'Избасканский район','Мархамат тумани':'Мархаматский район',
  'Олтинкўл тумани':'Алтыкульский район','Пахтаобод тумани':'Пахтаабадский район',
  'Қўрғонтепа тумани':'Кургантепинский район','Улуғнор тумани':'Улугнорский район',
  'Хонобод тумани':'Ханабадский район','Хўжаобод тумани':'Ходжаабадский район',
  'Шаҳрихон тумани':'Шахриханский район',
  // Fergana
  'Фарғона':'г. Фергана','Қўқон':'г. Коканд','Марғилон':'г. Маргилан','Қувасой':'г. Кувасай',
  'Қува тумани':'Кувинский район','Риштон тумани':'Риштанский район',
  'Бағдод тумани':'Багдадский район','Бешариқ тумани':'Бешарыкский район',
  'Бувайда тумани':'Бувайдинский район','Данғара тумани':'Дангаринский район',
  'Қуштепа тумани':'Куштепинский район','Сўх тумани':'Сохский район',
  'Тошлоқ тумани':'Ташлакский район','Фурқат тумани':'Фуркатский район',
  'Ёзёвон тумани':'Язяванский район',
  // Namangan
  'Наманган':'г. Наманган','Чуст тумани':'Чустский район','Поп тумани':'Папский район',
  'Косонсой тумани':'Касансайский район','Давлатобод тумани':'Давлатабадский район',
  'Мингбулоқ тумани':'Мингбулакский район','Норин тумани':'Норинский район',
  'Тўрақўрғон тумани':'Туракурганский район','Уйчи тумани':'Уйчинский район',
  'Учқўрғон тумани':'Учкурганский район','Янгиқўрғон тумани':'Янгикурганский район',
  'Янги Наманган тумани':'Янги-Наманганский район','Чортоқ тумани':'Чартакский район',
  // Samarkand
  'Самарқанд':'г. Самарканд','Каттақўрғон':'г. Каттакурган',
  'Ургут тумани':'Ургутский район','Пайариқ тумани':'Пайарыкский район',
  'Иштихон тумани':'Иштиханский район','Жомбой тумани':'Джамбайский район',
  'Оқдарё тумани':'Акдарьинский район','Булунғур тумани':'Булунгурский район',
  'Қўшрабод тумани':'Кошрабадский район','Нарпай тумани':'Нарпайский район',
  'Нуробод тумани':'Нурабадский район','Пастдарғом тумани':'Пастдаргомский район',
  'Пахтачи тумани':'Пахтачийский район','Тайлоқ тумани':'Тайлакский район',
  // Bukhara
  'Бухоро':'г. Бухара','Когон тумани':'г. Каган','Ромитан тумани':'Ромитанский район',
  'Қоракўл тумани':'Каракульский район','Ғиждувон тумани':'Гиждуванский район',
  'Вобкент тумани':'Вабкентский район','Жондор тумани':'Джандарский район',
  'Қоровулбозор тумани':'Каравулбазарский район','Олот тумани':'Алатский район',
  'Пешку тумани':'Пешкунский район','Шофиркон тумани':'Шафирканский район',
  // Navoi
  'Навоий':'г. Навои','Зарафшон':'г. Зарафшан','Ғозғон':'Газганский район',
  'Учқудуқ тумани':'Учкудукский район','Нурота тумани':'Нуратинский район',
  'Конимех тумани':'Конимехский район','Кармана тумани':'Карманинский район',
  'Қизилтепа тумани':'Кызылтепинский район','Навбаҳор тумани':'Навбахорский район',
  'Томди тумани':'Томдинский район','Хатирчи тумани':'Хатырчинский район',
  // Kashkadarya
  'Қарши':'г. Карши','Шаҳрисабз':'г. Шахрисабз','Қарши тумани':'Каршинский район',
  'Китоб тумани':'Китабский район','Кўкдала тумани':'Кукдалинский район',
  'Косон тумани':'Касанский район','Муборак тумани':'Мубарекский район',
  'Миришкор тумани':'Миришкорский район','Ғузор тумани':'Гузарский район',
  'Деҳқонобод тумани':'Дехканабадский район','Қамаши тумани':'Камашинский район',
  'Қасби тумани':'Касбинский район','Нишон тумани':'Нишанский район',
  'Чироқчи тумани':'Чиракчинский район','Яккабоғ тумани':'Яккабагский район',
  // Surkhandarya
  'Термиз':'г. Термез','Ангор тумани':'Ангорский район','Денов тумани':'Денауский район',
  'Шеробод тумани':'Шерабадский район','Бойсун тумани':'Байсунский район',
  'Бандихон тумани':'Бандиханский район','Жарқўрғон тумани':'Джаркурганский район',
  'Қизириқ тумани':'Кизирикский район','Қумқўрғон тумани':'Кумкурганский район',
  'Музработ тумани':'Музрабадский район','Олтинсой тумани':'Алтынсайский район',
  'Сариосиё тумани':'Сариасийский район','Узун тумани':'Узунский район',
  'Шўрчи тумани':'Шурчинский район',
  // Jizzakh
  'Жиззах':'г. Джизак','Зомин тумани':'Заминский район','Ғаллаорол тумани':'Галляаральский район',
  'Янгиобод тумани':'Янгиабадский район','Арнасой тумани':'Арнасайский район',
  'Бахмал тумани':'Бахмалский район','Дўстлик тумани':'Дустликский район',
  'Зарбдор тумани':'Зарбдарский район','Зафаробод тумани':'Зафарабадский район',
  'Мирзачўл тумани':'Мирзачульский район','Пахтакор тумани':'Пахтакорский район',
  'Фориш тумани':'Фаришский район','Шароф Рашидов тумани':'Шараф-Рашидовский район',
  // Sirdarya
  'Гулистон':'г. Гулистан','Янгиер':'г. Янгиер','Ширин':'г. Ширин',
  'Хавос тумани':'Хавастский район','Сардоба тумани':'Сардобинский район',
  'Оқолтин тумани':'Акалтынский район','Боёвут тумани':'Баяутский район',
  'Мирзаобод тумани':'Мирзаабадский район','Сайхунобод тумани':'Сайхунабадский район',
  'Сирдарё тумани':'Сырдарьинский район',
  // Khorezm
  'Урганч':'г. Ургенч','Хива':'г. Хива','Питнак':'г. Питнак',
  'Хонқа тумани':'Ханкинский район','Шовот тумани':'Шаватский район',
  'Боғот тумани':'Багатский район','Гурлан тумани':'Гурленский район',
  'Қўшкўпир тумани':'Кушкупырский район','Хазорасп тумани':'Хазараспский район',
  'Янгиариқ тумани':'Янгиарыкский район','Янгибозор тумани':'Янгибазарский район',
  // Karakalpakstan
  'Нукус':'г. Нукус','Тахиатош':'г. Тахиаташ','Тўрткўл':'г. Турткуль',
  'Хўжайли':'г. Ходжейли','Чимбой':'г. Чимбай',
  'Беруний тумани':'Берунийский район','Қўнғирот тумани':'Кунградский район',
  'Амударё тумани':'Амударьинский район','Кегейли тумани':'Кегейлийский район',
  'Қонликўл тумани':'Канликольский район','Мўйноқ тумани':'Муйнакский район',
  'Тахиатош тумани':'Тахиатошский район','Тахтакўпир тумани':'Тахтакупырский район',
  'Шўманай тумани':'Шуманайский район','Элликқалъа тумани':'Элликкалинский район',
};

// Returns "Бухоро шаҳри, Бухоро вилояти" or "Хатирчи тумани, Навоий вилояти" etc.
export function displayLocation(canonical, t, language = 'uz') {
  if (!canonical) return '';

  const oblastKey = OBLAST_TO_KEY[canonical];
  if (oblastKey) return t(`regions.${oblastKey}`);

  const parentKey = SUBREGION_TO_PARENT_KEY[canonical];
  if (parentKey) {
    const label = language === 'ru'
      ? (CITY_LABEL_RU[canonical] || canonical)
      : (CITY_LABEL[canonical] || canonical);
    return `${label}, ${t(`regions.${parentKey}`)}`;
  }

  return canonical;
}
